import React, {useEffect, useState} from 'react';
import {
    RichCell,
    PanelHeader,
    Div,
    SplitCol,
    SplitLayout,
    Button,
    DateRangeInput
} from '@vkontakte/vkui';
import axios from "axios";
import {addDays} from "@vkontakte/vkui/dist/lib/date";
import {AdaptivityContext, inducement} from "../assets/constants";
import {Icon24Refresh} from "@vkontakte/icons";


const MonitoringDocs = (props) => {
    const [value, setValue] = useState([addDays(new Date(), -10), new Date()]);
    const [items, setItems] = useState([]);

    const dateChange = (e) => {
        console.log(e)
        setValue(e)
        getItems(e)
    }

    const getItems = (range = [addDays(new Date(), -10), new Date()], mainSearch = '', append = false, page = 1) => {
        append = append == undefined ? false : append

        let body = new FormData()
        body.append('page', page)
        body.append('start', range[0].toLocaleDateString())
        body.append('end', range[1].toLocaleDateString())
        body.append('epp', AdaptivityContext.isMobile ? 10 : 25)

        axios.post(props.base_url + '?app=MonitoringDocs&act=showManyJson2', body,
            {
                withCredentials: true

            }
        ).then((response) => {
            setItems(response.data.results)

        })

    };


    const getDoc = (id) => {

        let body = new FormData()

        body.append('id', id)

        axios.post(props.base_url + '?app=MonitoringDocs&act=showOne', body,
            {
                withCredentials: true

            }
        ).then((response) => {

            if (response.data.doc_data) {
                props.select_doc(response.data)
            }


        })

    };
    useEffect(() => {
        getItems()
    }, []);


    return (
        [<PanelHeader fixed={true}
                      after={<div style={{display: "flex"}}>
                          <DateRangeInput

                          mode="plain"
                          closeOnChange={false}
                          value={value}
                          onChange={dateChange}/>
                          <Button size="s" mode="tertiary" style={{maxWidth: "42px"}} onClick={() => {
                             setItems([])
                              getItems(value)
                          }}><Icon24Refresh/></Button>
                      </div>
                      }
        >
            <Div>
                Мониторинг

            </Div>
        </PanelHeader>,
            items.map((item, index) => (
                <SplitLayout>
                    <SplitCol>
                        <RichCell onClick={() => getDoc(item.id)} multiline
                                  bottom={<Button size="s">{item.status_name}</Button>}
                                  subhead={<span style={{fontSize: 'smaller'}}>{item.date} {item.time}</span>}
                                  after={'Автор: ' + item.user.name}
                                  afterCaption={item.meta.Товары.length + ' ' + inducement(item.meta.Товары.length, 'позиция', 'позиции', 'позиций')}
                                  text={item.last_hist != undefined && item.last_hist[0].meta != undefined
                                  && item.last_hist[0].meta.ОтветственныйПодробно != undefined
                                  && item.last_hist[0].meta.ОтветственныйПодробно.ФИО != undefined ? item.last_hist[0].meta.ОтветственныйПодробно.ФИО : ''}

                        >
                            {item.NomerDocKIS ? item.NomerDocKIS : 'Номер в 1С еще не получен'}


                        </RichCell>
                    </SplitCol>
                </SplitLayout>

            ))
        ]
    )

}

export default MonitoringDocs